import { z } from "zod";

// Schema
// export const urlSchema = z.object({
//   label: z.any(),
//   href:  z.any(),
// });

export const urlSchema = z
  .preprocess((value) => {
    if (typeof value === "string") {
      return { label: value, href: "" };
    }

    return value;
  }, z.object({ label: z.any(), href: z.any() }))
  .transform((value) => {
    if (value && typeof value === "object") {
      return {
        label: "label" in value ? value.label : "",
        href: "href" in value ? value.href : "",
      };
    }

    return { label: "", href: "" };
  });

// Type
export type URL = z.infer<typeof urlSchema>;

// Defaults
export const defaultUrl: URL = {
  label: "",
  href: "",
};
